import React, { useState } from 'react';
import { Icon } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import MinimizeIcon from '@material-ui/icons/Minimize';

import { Container, Title, IconWrapper, Content, ExpandWrapper, StyledAvatar } from './styles';
import { useChatState, useTheme } from '../../data';

export interface ChatHeaderProps {
  title?: string;
  titleColor?: string;
  backgroundColor?: string;
  icon?: string;
  logo?: string;
  forceResponsiveMode?: boolean
}

const ChatHeader: React.FC<ChatHeaderProps> = (props) => {
  const { showChat, setShowChat, isMobile, setIsExpanded, isExpanded } = useChatState();
  const { title, titleColor, backgroundColor, icon } = useTheme().header!;
  const [overflow, setOverflow] = useState<string>(document.querySelector('body')!.style.overflow);

  const handleClick = () => {
    if (showChat) {
      document.querySelector('body')!.style.overflow = overflow;
      setIsExpanded(false);
    } else if (isMobile || props.forceResponsiveMode) {
      setOverflow(document.querySelector('body')!.style.overflow);
      document.querySelector('body')!.style.overflow = 'hidden';
    }
    
    setShowChat(!showChat);
  }

  const handleExpand = () => {
    if (isExpanded) {
      document.querySelector('body')!.style.overflow = overflow;
    } else {
      setOverflow(document.querySelector('body')!.style.overflow);
      document.querySelector('body')!.style.overflow = 'hidden';
    }

    setIsExpanded(!isExpanded);
  }

  return (
    <Container
      as="sdiv"
      backgroundColor={backgroundColor!}
      showChat={showChat}
      isExpanded={isExpanded}
      onClick={showChat ? () => {} : handleClick} 
      forceResponsiveMode={props.forceResponsiveMode!}
      isMobile={isMobile}
      icon={(!!props.icon)}
    >
      <Content as="sdiv" color={titleColor!}>
        { props.icon && (isMobile || props.forceResponsiveMode) && !showChat ? 
          <StyledAvatar src={props.icon}></StyledAvatar> :
          <IconWrapper as="sdiv" showChat={showChat} onClick={handleClick} forceResponsiveMode={props.forceResponsiveMode!}>
            {showChat ? <CloseIcon /> : <Icon className={icon}></Icon>}
          </IconWrapper>
        }
        <Title as="sdiv" showChat={showChat} forceResponsiveMode={props.forceResponsiveMode!}>{title}</Title>
        {showChat &&
          <ExpandWrapper as="sdiv" onClick={handleExpand}>
            {isExpanded ? <MinimizeIcon /> : <ZoomOutMapIcon />}
          </ExpandWrapper>
        }
      </Content>
    </Container>
  );
}

export default ChatHeader;